import { queryOptions } from '@tanstack/react-query';
import { fetchProductMeta } from './DocumentUtils';

export const productMetaQuery = (isbn: string) =>
  queryOptions({
    queryKey: ['productMeta', isbn],
    queryFn: () => fetchProductMeta(isbn),
  });
